import { ApplicationConfig, ErrorHandler, APP_INITIALIZER, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { appInterceptor } from './interceptors/app.interceptor';
import { loadingInterceptor } from './interceptors/loading.interceptor';
import { errorInterceptor } from './interceptors/error-http.interceptor';
import { LoadingService } from './services/loading/loading.service';
import { RumInitializerService } from './services/rum/rum-initializer.service';
import { RumErrorHandler } from './error-handlers/rum-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([appInterceptor, loadingInterceptor, errorInterceptor])),
    LoadingService,
    {
      provide: APP_INITIALIZER,
      useFactory: (rumService: RumInitializerService) => () => rumService.initializeRum(),
      deps: [RumInitializerService],
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: RumErrorHandler
    },
  ]
};
